import { Component } from "@angular/core";
import { Location } from "@angular/common";

@Component({
  selector: "bko-tilbake-link",
  standalone: true,
  templateUrl: "./tilbake-link.html",
  styleUrl: "./tilbake-link.scss",
})
export class TilbakeLink {
  constructor(private location: Location) {}

  onTilbakeKlikk(): void {
    this.location.back();
  }
}
